<template>
  <div class="card mt-3">
    <div class="card-body">
      <div v-for="qqs in quotes" :key="qqs.id">

        <div class="row mt-3">
          <div class="col-sm-12 text-star d-flex align-items-center gap-2">
            <h5 class="card-title inline mb-0">{{ qqs.id }} - {{ qqs.name }}</h5>
            <span v-if="isDeactivated(qqs)" class="badge bg-secondary">Deactivated</span>
            <button v-else type="button" class="btn btn-sm btn-outline-primary" @click="editQuote(qqs)">
              <i class="bi bi-pencil"></i> Edit
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">

            <ul class="list-group list-group-flush">
              <li v-for="item in qqs.items" :key="item.id" class="list-group-item">
                <div class="row">
                  <div class="col-sm-10">{{ item.name }}</div>
                  <div class="col-sm-1"><button v-if="item.idType == 100 && !isDeactivated(qqs)"
                      @click="verAssessment(item.idSource, item.name)" type="button" class="btn btn-secondary">
                      <i class="bi bi-eye"></i>
                    </button></div>
                  <div class="col-sm-1">
                    <router-link
                      v-if="item.idType == 100 && !isDeactivated(qqs)"
                      :to="`/administration/assmt/${item.idSource}`"
                      class="btn btn-secondary"
                      role="button"
                    >
                      <i class="bi bi-box-arrow-up-right"></i>
                    </router-link>
                  </div>
                </div>
                <div class="row" v-if="item.idType != 100">
                  <div class="col-sm-10">{{ item.description }}</div>
                </div>


              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>

  </div>

  <quoteItem ref="quoteItemCmp"></quoteItem>

</template>
<script setup>
import { onMounted, ref, defineProps } from "vue";
import vtc from "@/helpers/vtc.js";
import quoteItem from "../../components/global/quote-item.vue";

const quoteItemCmp = ref(null);

//const router = useRouter();
const quotes = ref([])
const props = defineProps({
  idProject: {
    type: Number,
    default: null
  },
  idClient: {
    type: Number,
    default: null
  }
})

onMounted(async () => {
  let idp = props.idProject

  vtc.vtcFetch(`/Quote/GetQuotesForProject?projectId=${idp}`, null, "API2").then(function (data) {
    console.log("quotesproject", data)
    quotes.value = data
  });
});

let verAssessment = (id, name) => {
  quoteItemCmp.value.open(id, name);
}

let editQuote = (quote) => {
  const quoteClientId = quote.idClient || quote.IdClient || props.idClient || "null";
  const quoteId = quote.id || quote.Id;
  window.location.href =
    vtc.getConfig().getHomeUrl() + `/newquote/null|${quoteClientId}|${props.idProject}|${quoteId}`;
}

let isDeactivated = (quote) => {
  return quote.deActivated === true || quote.DeActivated === true;
}

</script>
